// The fragment parameters a flow token travels in. The backend builds links
// with the token and the website, and the dashboard adds the landing path when
// it sends a token on to the flow token page.
export const FLOW_TOKEN_KEY = 'flow_token'
export const FLOW_TOKEN_LANDING_PATH_KEY = 'next'
export const FLOW_TOKEN_WEBSITE_KEY = 'website'

export const FLOW_TOKEN_PAGE_PATH = '/dashboard/flow-token.html'

export const FLOW_TOKEN_REJECTED_MARKER = 'flow_token_rejected'

// Set on the window by a dashboard page that is leaving for the flow token
// page, which the dashboard checks before it starts.
export const FLOW_TOKEN_DEPARTURE_GLOBAL = '__termlyFlowTokenDeparture'
